<template>
  <el-row :gutter="10" >
    <el-col :span="4">
      <el-cascader
          v-model="deptId"
          :show-all-levels="false"
          :options="deptCascader"
          :props="optionProps"
          placeholder="部门"
          clearable
      ></el-cascader>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeNo" placeholder="员工工号" clearable/>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeName" placeholder="员工姓名" clearable/>
    </el-col>
    <el-col :span="4">
      <el-button type="primary" @click="getBalance" :loading="loading" >搜索</el-button>
      <el-button type="primary" @click="getLatestLeaveBalance" >刷新数据</el-button>
    </el-col>
    <el-col :span="5" :offset="3">
      <label>{{this.syncTime}}</label>
    </el-col>
  </el-row>
  <div style="display: inline-flex;margin-bottom: 10px;margin-top: 5px;">

  </div>
  <el-table :data="balanceList" stripe border fit style="width: 100%;;height: 80%" row-style="height:35px;" size="small">
    <el-table-column label="姓名" prop="employee_name" fixed width="100" align="center" ></el-table-column>
    <el-table-column label="部门" prop="dept" fixed width="100" align="center" ></el-table-column>
    <el-table-column label="入职时间" prop="entry_date" width="110" align="center" ></el-table-column>
    <el-table-column v-for="rule in ruleList" :label="rule.vacation_name" :prop="rule.id" :key="rule.id"
                     align="center" width="120">
    </el-table-column>
  </el-table>
</template>

<script>

export default {
  name: "LeaveBalance",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'id',
        label: 'name',
        checkStrictly:true
      },
      loading: false,
      balanceList: [],
      ruleList: [],
      deptId:'',
      employeeNo:'',
      employeeName:'',
      deptCascader:[],
      syncTime:''
    }
  },
  methods: {
    getLatestLog(){
      //查询数据
      let params = {
        menu: '假期余额'
      }
      this.$http('attendanceLogService.getLatestLog', params).then(data => {
        this.syncTime = data
      })
      console.log(this.syncTime);
    },
    async getDepartmentCascader() {
      this.deptCascader = await this.$http("sysUserDepartmentService.getDepartmentData");
    },
    async getBalance() {
      let params = {
        deptId:this.deptId,
        employeeNo:this.employeeNo,
        employeeName:this.employeeName
      }
      //查询数据
      let rtn = await this.$http('vacationRulesService.getLeaveBalanceList',params);
      if(!rtn){
        return;
      }
      //赋值
      this.balanceList = rtn;
      this.ruleList = rtn[0].rule_list;
    },
    async getLatestLeaveBalance() {
      await this.$http('dingVacationService.getAllLeaveBalance');
      await this.getBalance();
      this.$message.success("刷新成功")
    }
  },
  created() {
    this.getLatestLog();
    this.getDepartmentCascader();
  }
}
</script>

<style scoped lang="less">

</style>